import PropTypes from 'prop-types'
import React from 'react'
import { formatDate } from '../../../common/utils'

const DateComponent = ({ date }) => (
  <span className="mb-5 text-xs font-normal text-gray-510">
    {formatDate(date)}
  </span>
)

DateComponent.propTypes = {
  date: PropTypes.string.isRequired,
}

export default DateComponent
